import { FaRegStar, FaStar } from 'react-icons/fa'

type TRating = {
  rating: number
  onChange: (value: number) => void
}

export default function Rating({ rating, onChange }: Readonly<TRating>) {
  return (
    <div className='flex flex-row items-center'>
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          type='button'
          key={star}
          onClick={() => onChange(star)}
          aria-label={`Rate ${star} star${star > 1 ? 's' : ''}`}
          data-testid={`${star}-star`}
        >
          {rating && star <= rating ? (
            <FaStar className='m-2 h-8 w-8 text-pop-yellow-200' data-testid='fa-star' />
          ) : (
            <FaRegStar className='m-2 h-8 w-8 text-pop-yellow-200' data-testid='fa-reg-star' />
          )}
        </button>
      ))}
    </div>
  )
}
